


























import { defineComponent, computed } from '@nuxtjs/composition-api'

import PriceBrickContent from '~/components/feature/price-brick/PriceBrickContent.vue'
import OldPriceBrickContent from '~/components/feature/price-brick/OldPriceBrickContent.vue'
import { usePriceBrick } from '~/composables/price-brick/usePriceBrick'

import useEcommerceAnalytics from '@/composables/analytics/useEcommerceAnalytics'

import { PRODUCT_STATUS } from '@/common/utils/product/constants'

import { AddItemToBasketInterface } from '@/types/checkout/checkoutTypes'
import { MappedProduct } from '@cstweb/site/types/product/productTypes'

import { useI18n } from '~/composables/i18n'
import { useCountry } from '~/composables/country/useCountry'
import { useCMSGlobalSettingsStore } from '@/store/cms'

export default defineComponent({
  components: { PriceBrickContent, OldPriceBrickContent },
  props: {
    productData: {
      type: Object as () => MappedProduct,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    isCnDangerousProduct: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['hideModal'],
  setup(props, { emit }) {
    const { trackAddToCart, trackAddToOldPriceBrick } = useEcommerceAnalytics()
    const { mapSkuData, showInventory, showOldPriceBrick, getCustomFormulationLabel } = usePriceBrick()
    const { t } = useI18n()
    const { getAttributeByCountry } = useCMSGlobalSettingsStore()
    const { isJapan, isCN } = useCountry()
    const pageName = props.page === 'PLP' ? 'Product Listing Page' : 'Product Compare Page'

    const excludeProductsUS = getAttributeByCountry('excludedProducts', 'US').value
    const excludeProductsJP = getAttributeByCountry('excludedProducts', 'JP').value

    const onAddToBasket = (params: { items: Array<AddItemToBasketInterface>; trackAsOldPriceBrick: boolean }) => {
      if (params.trackAsOldPriceBrick) {
        trackAddToOldPriceBrick(pageName, params.items)
      } else {
        trackAddToCart(pageName, params.items)
        emit('hideModal')
      }
    }

    const customFormulationLabel = computed(() => {
      return getCustomFormulationLabel(props.productData.productCategory)
    })

    const mappedSkuData = mapSkuData(Object.values(props.productData.skuData))

    const isForbiddenToSell = computed(() => {
      if ((!showOldPriceBrick.value || isCN.value) && excludeProductsUS.includes('' + props.productData.key)) {
        return true
      }
      if (isJapan.value && excludeProductsJP.includes('' + props.productData.key)) {
        return true
      }
    })

    const blueMessageDisplayCondition = computed(() => {
      return (
        props.productData.attributes.statusDates.status === PRODUCT_STATUS.PENDING ||
        mappedSkuData.length === 0 ||
        isForbiddenToSell.value
      )
    })

    return {
      t,
      onAddToBasket,
      mapSkuData,
      showOldPriceBrick,
      showInventory,
      blueMessageDisplayCondition,
      mappedSkuData,
      customFormulationLabel,
    }
  },
})
